module.exports = __webpack_public_path__ + "img/suivre-dossier.f9d334b3.svg";